import { useState } from 'react';
import { FaEdit } from 'react-icons/fa';

import ComponentModal from '../../../reusable/component-modal/component-modal.component';
import UpdateShippingType from './update/update-shipping-type.component';

import {
  MainContainer,
  TypeOptionsContainer,
  TypeDataContainer,
  TypeContainerRow,
  TypeDataTitle,
  TypeDataText
} from './shipping-type-display.styles';

const ShippingTypeDisplay = ({ type, getType }) => {
  const [showUpdate, setShowUpdate] = useState(false);

  return (
    <MainContainer>
      <ComponentModal
        isOpen={showUpdate}
        onClose={() => setShowUpdate(false)}
        title="Update Shipping Type"
      >
        <UpdateShippingType
          typeData={type}
          getType={getType}
          setShowUpdate={setShowUpdate}
        />
      </ComponentModal>

      <TypeOptionsContainer>
        <FaEdit onClick={() => setShowUpdate(true)} />
      </TypeOptionsContainer>

      <TypeDataContainer>
        <TypeContainerRow>
          <TypeDataTitle>Name:</TypeDataTitle>
          <TypeDataText>{type.name}</TypeDataText>
        </TypeContainerRow>
        <TypeContainerRow>
          <TypeDataTitle>Speed (days):</TypeDataTitle>
          <TypeDataText>{type.speedDays ?? '—'}</TypeDataText>
        </TypeContainerRow>
      </TypeDataContainer>
    </MainContainer>
  );
};

export default ShippingTypeDisplay;